import { v4 as uuidv4 } from "uuid";
import { List, ListItemButton, Select, TextField, MenuItem, CircularProgress, Box } from "@mui/material"
import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setProjectTrackedTime, setProjectType, setStateSelectedProject, getProjectType } from "../../store/projectSlice";
import { RootState } from "../../store/store";
import './style.scss';
import { clearStateIssue } from "../../store/IssueSlice";
import { getJiraAccessToken, getJiraRedirectUrl, getJiraToken, getJiraTrackedTime, validateUser } from "../../services/jira.service";
import { toast } from "react-toastify";
import { setTrackingTimeLogged } from "../../store/trackingSlice";
import {
  getAccessToken,
  getOpenProjectTrackedTime,
  getRedirectUrl,
  getToken,
  validateUser as OPValidateUser,
} from "../../services/openProject.service";
import { ProjectContext } from "../Homepage";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import AddIcon from "@mui/icons-material/Add";
import NewProject from '../../components/NewProject';
import ProjectHierarchy from "../../components/ProjectHierarchy";
import { ProjectList } from "../../common/interface";
import _ from "lodash";
import { setUserJiraState, setUserOpState } from "../../store/userSlice";
import { listenToAuthCodeChanges } from "../../utils/helper";

export const formatTimeWithSecond = (timeInSeconds: number):string=>{
  const hours: number = Math.floor(timeInSeconds / 3600);
  const minutes: number = Math.floor((timeInSeconds % 3600) / 60);
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}

const ProjectListPage = () => {

  const projectState = useSelector((state: RootState) => state.project);
  const trackerState = useSelector((state: RootState) => state.tracker);
  const issueState = useSelector((state: RootState) => state.issue);
  const userState = useSelector((state: RootState) => state.user);
  const userDetails = userState?.user;
  
  const dispatch = useDispatch();

  const projectSelectedProject = projectState.selectedProject;
  const projectTypeMenu = projectState.projectTypeMenu
  const projectType = useSelector(getProjectType);
  const projects_trackedTime = projectState.projects_trackedTime
  const task_project_commonFieldForSpentTime = issueState.task_project_commonFieldForSpentTime 
  const isIssueTracking = trackerState.isTracking
  const trackingTimeLogged = trackerState.trackingTimeLogged

  const [searchProject, setSearchProject] = useState('');
  const [projectArray, setProjectArray] = useState<ProjectList[]>([]);
  const [filteredProject, setFilteredProject] = useState<ProjectList[]>([]);
  const [isListingAllTask, setIsListingAllTask] = useState<boolean>(true);
  const { projectList, loader, jiraProjectList, selectedNotification, setSelectedNotification } = useContext(ProjectContext);

  const [loading, setLoading] = useState(loader);
  const [jiraProjects, setJiraProjects] = useState(jiraProjectList);
  const [openProjects, setOpenProjects] = useState(projectList);
  const [newProjectVisibility, setNewProjectVisibility] = useState<boolean>(false);

  const handleNewProjectVisibility = () => {
    setNewProjectVisibility(!newProjectVisibility);
  };


  const handleSearch = (event: any) => {
    setSearchProject(event.target.value);
  }

  const setDailyTrackerTimeByGetAllTaskData = async({loader=true, projectData=[]}:{loader?:boolean, projectData?: ProjectList[] })=> {
    let allTaskData = projectData || [];
    
    try {
      if(loader)setLoading(true);
      if(userDetails?.openProjectDetails?.id && allTaskData.length === 0){
        const ldapUserId = userDetails?.openProjectDetails?.id
        const admin = userDetails?.openProjectDetails?.admin;
        const taskResponse = await getOpenProjectTrackedTime(ldapUserId,admin);
        allTaskData = taskResponse?.data?._embedded?.elements || []
      }
    } catch (error) {
      toast.error('Failed to fetch Open project details');
      allTaskData = []
    }finally{
      setLoading(false)
    }
    function extractTasks(tasks: any[]): { projectLink: string; todaySpentTimeInSec: number }[] {
      let result: { projectLink: string; todaySpentTimeInSec: number }[] = [];
      function traverse(task: any) {
        if (!task) return;
        result.push({
          projectLink: task?.projectLink,
          todaySpentTimeInSec: task?.dailyTrackerTime || 0,
        });
        if (Array.isArray(task.subProjects)) {
          task.subProjects.forEach(traverse);
        }
      }
      tasks.forEach(traverse);
      return result;
    }

    let taskList = extractTasks(allTaskData || []);
    let project_trackedTime: any = {}
    for (let task of taskList) {
      if (project_trackedTime?.[task?.projectLink]) {
        project_trackedTime[task?.projectLink] = project_trackedTime[task?.projectLink] + task.todaySpentTimeInSec
      } else {
        project_trackedTime[task?.projectLink] = task.todaySpentTimeInSec
      }
    }

    dispatch(setProjectTrackedTime(project_trackedTime))
  } 



  const setDailyTrackerTimeByGetAllJiraTask = async({loader=true}:{loader?:boolean}, jiraProjectList?: ProjectList[] )=>{
    let projectList = jiraProjectList || [];
    try {
      if(loader)setLoading(true);
      if(userDetails?.jiraDetails?.accountId && projectList.length === 0){
        const allTaskResponse = await getJiraTrackedTime(userDetails?.jiraDetails?.accountId);
        projectList = allTaskResponse?.data || [];
      }

      let projects = projectList?.map((e: any) => {
        return {
          task_project_commonFieldForSpentTime: e?.key , // project key is common field in open project task and project
          todaySpentTimeInSec : e?.dailyTrackerTime
        }
      }) || []
  
      let project_trackedTime:any = {}
      for(let project of projects){
        if(project_trackedTime?.[project?.task_project_commonFieldForSpentTime]){
          project_trackedTime[project?.task_project_commonFieldForSpentTime] = project_trackedTime[project?.task_project_commonFieldForSpentTime] +  project.todaySpentTimeInSec
        }else{
          project_trackedTime[project?.task_project_commonFieldForSpentTime] = project.todaySpentTimeInSec;
        }
      }
  
      dispatch(setProjectTrackedTime(project_trackedTime));
    } catch (error) {
      projectList = [];
    }finally{
      setLoading(false)
    }
  }

  const handleListSelection = (event: any, projectData: any, flag: boolean = false) => {
    if (!isIssueTracking) {
      dispatch(clearStateIssue());
      if (projectData.id === projectSelectedProject?.id && !flag) {
        dispatch(setStateSelectedProject(null));
        setIsListingAllTask(true)
      }else{
        setIsListingAllTask(false)
        dispatch(setStateSelectedProject(projectData));
      }  
    } else {
      toast.error('Tracker is Running')
    }
  };

  const getOPUrl = async () => {
    try {
      const response = await getRedirectUrl();

      if (response.statusCode === 200 && response.data) {
        console.log("[OP_SEND_STATE]", userState.opState);
        const url = response.data;
        const windowFeatures =
          "width=800,height=600,resizable=yes,scrollbars=yes";
        const popup = window.open(
          url + `&state=${userState.opState}`,
          "open project oauth",
          windowFeatures
        );

        console.log("[TESTING] POPUP OPENED");

        // If popup is blocked by the browser
        if (!popup) {
          alert("Popup blocked by browser");
        }
      }
    } catch (error) {
      console.error("Error fetching OP redirect URL:", error);
    }
  };

  const getJiraUrl = async () => {
    try {
      const response = await getJiraRedirectUrl();
      if (response.statusCode === 200 && response.data) {
        const url = response.data;
        const windowFeatures =
          "width=800,height=600,resizable=yes,scrollbars=yes";
        const popup = window.open(
          url + `&state=${userState.jiraState}`,
          "open project oauth",
          windowFeatures
        );
        if (!popup) {
          alert("Popup blocked by browser");
        }
      }
    } catch (error) {
      console.error("Error fetching Jira redirect URL:", error);
    }
  };

  const refreshToken = localStorage.getItem("jiraRefreshToken");
  const refreshJiraToken = async () => {
    try {
      if (refreshToken) {
        const { data } = await getJiraAccessToken(refreshToken);
        if (data?.access_token && data?.refresh_token) {
          const isValidUser = await validateUser(data.access_token);
          if (isValidUser?.data?.accountId) {
            localStorage.setItem(
              "jiraAccessToken",
              JSON.stringify(data.access_token)
            );
            localStorage.setItem(
              "jiraRefreshToken",
              JSON.stringify(data.refresh_token)
            );
            return true;
          }
        }
      }
    } catch (error) {
      console.error("Error during Jira authentication:", error);
    }
  };

  const refreshOpenProjectToken = async () => {
    try {
      const refresh_token = localStorage.getItem("openProjectRefreshToken");

      // If no refresh token is available, exit early.
      if (!refresh_token) {
        console.log("No refresh token found");
        return;
      }

      const { data } = await getAccessToken(refresh_token);
      console.log("[TESTING] GET OP ACCESS TOKEN DATA", data);

      // Check if the response contains necessary tokens
      if (!data?.access_token || !data?.refresh_token) {
        console.log("Invalid response data: missing access or refresh token");
        return;
      }

      // Validate user
      const isValidUser = await OPValidateUser(data.access_token);
      if (isValidUser?.data?.id) {
        // Store tokens in localStorage
        localStorage.setItem(
          "openProjectAccessToken",
          JSON.stringify(data.access_token)
        );
        localStorage.setItem(
          "openProjectRefreshToken",
          JSON.stringify(data.refresh_token)
        );

        console.log(
          "[TESTING] OP Access Token successfully set in localStorage"
        );
        return true;
      } else {
        console.log("Invalid user data");
      }
    } catch (error) {
      console.error("Error during OpenProject authentication:", error);
    }
  };

  useEffect(() => {
    const init = async () => {
      if (userState.jiraState === "null" || !userState.jiraState) {
        dispatch(setUserJiraState(uuidv4()));
      }
      if (userState.opState === "null" || !userState.opState) {
        dispatch(setUserOpState(uuidv4()));
      }
    };

    init();
  }, [userState.jiraState, dispatch]);

  const jiraAccessToken = localStorage.getItem("jiraAccessToken") || "";
  const OPAccessToken = localStorage.getItem("openProjectAccessToken") || "";
  useEffect(() => {
    if (
      (!jiraAccessToken || jiraAccessToken === "null") &&
      userState.jiraState !== "null" &&
      userState.jiraState
    ) {
      listenToAuthCodeChanges(
        "jira",
        userState.jiraState,
        getJiraToken,
        (userName: string) => {},
        refreshJiraToken,
        dispatch
      );
    }
    if (
      (!OPAccessToken || OPAccessToken === "null") &&
      userState.opState !== "null" &&
      userState.opState
    ) {
      listenToAuthCodeChanges(
        "openProject",
        userState.opState,
        getToken,
        (userName: string) => {},
        refreshOpenProjectToken,
        dispatch
      );
    }
  }, [userState.jiraState, dispatch, userState.opState]);

  const handlePlatformSwitching = async (platform: string) => {
    // Function to handle authentication logic for both Jira and OpenProject
    const handlePlatformAuthentication = async (
      platform: string,
      accessToken: string | null,
      refreshToken: string | null
    ) => {
      if (!accessToken || accessToken === "null") {
        // Call the respective URL function based on the platform
        if (platform === "Jira") {
          await getJiraUrl();
        } else if (platform === "WayMore Project") {
          await getOPUrl();
        }
      } else if (refreshToken) {
        // Refresh token logic for both platforms
        const isRefreshed =
          platform === "Jira"
            ? await refreshJiraToken()
            : await refreshOpenProjectToken();
        if (isRefreshed) {
          dispatch(setProjectType(platform));
        } else {
          toast.info("Token Expired");
          platform === "Jira" ? await getJiraUrl() : await getOPUrl();
        }
      } else {
        dispatch(setProjectType(platform));
      }
    };

    // Check for Jira or OpenProject
    if (platform === "Jira" || platform === "WayMore Project") {
      const accessToken = platform === "Jira" ? jiraAccessToken : OPAccessToken;
      await handlePlatformAuthentication(platform, accessToken, refreshToken);
    } else {
      dispatch(setProjectType(platform));
    }
  };

  const handleProjectTypeChange = (event: any) => {
    if (!isIssueTracking) {
      handlePlatformSwitching(event.target.value);
    } else {
      toast.error("Tracker is Running");
    }
  };

  const getProjectList = async (projectList: ProjectList[]) => {
    let projectData = []
    setLoading(true);

    if(userDetails?.openProjectDetails?.id) {
      projectData = openProjects.length ? openProjects : projectList;
    }

    if(Array.isArray(projectData) && projectData.length ) {
    
      setFilteredProject(_.cloneDeep(projectList));
      setProjectArray(_.cloneDeep(projectList));
      await setDailyTrackerTimeByGetAllTaskData({loader:true, projectData});
      setLoading(false);
    }else{
      setLoading(false);
      setFilteredProject(() => []);
      setProjectArray(() => []);
    }
  };

  const getJiraProjectList = async () =>{
    let jiraProjectData = []
    setLoading(() => true);
    if(userDetails?.jiraDetails?.accountId) {
      jiraProjectData = jiraProjectList || jiraProjects;
    }
    if(Array.isArray(jiraProjectData) && jiraProjectData.length){
      const jiraProjectLists:any = jiraProjectData.map((e:any)=>{
        return {
          name: e?.name,
          id: e?.id,
          projectSpentTime: e?.dailyTrackerTime,
          projectSpentTimeInsecond: e?.dailyTrackerTime,
          projectLink: e?.self,
          projectKey: e?.key,
          task_project_commonFieldForSpentTime: e?.key
        }
      })
      setFilteredProject(() => [...jiraProjectLists]);
      setProjectArray(() => [...jiraProjectLists]);
      await setDailyTrackerTimeByGetAllJiraTask({loader:true}, jiraProjectData);
      setLoading(() => false);
    }else {
      setLoading(false);
      setFilteredProject(() => []);
      setProjectArray(() => []);
    }
  }



  useEffect(() => {
    if(!searchProject) {
      setFilteredProject([...projectArray])
      return;
    }

    let filterResult = projectArray.filter(e => e.name.toLocaleLowerCase().includes(searchProject.toLocaleLowerCase()));
    setFilteredProject([...filterResult]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchProject])


  useEffect(() => {
    if ((filteredProject.length || projectArray.length) && projectType !== projectTypeMenu[0]) {
      const filteredProjectWithTime: any = filteredProject.map(e => {
        const projectSpentTimeInsecond = projects_trackedTime[e?.task_project_commonFieldForSpentTime] || 0
        return { ...e, projectSpentTimeInsecond }
      })
      const projectListWithTime :any =  projectArray.map(e=>{
        const projectSpentTimeInsecond = projects_trackedTime[ e?.task_project_commonFieldForSpentTime ] || 0
        return {...e,projectSpentTimeInsecond }
      })
      setFilteredProject(_.cloneDeep(filteredProjectWithTime));
      setProjectArray(_.cloneDeep(projectListWithTime));
    } else {
      const addAggregatedSpentTime = (projects: any[], trackedTime: Record<string, number>): any[] => {
        function traverse(project: any): any {
          if (!project) return null;
          let subProjects = Array.isArray(project.subProjects)
            ? project.subProjects.map(traverse)
            : [];
          const subProjectsTotalTime = subProjects.reduce(
            (sum: number, sub: any) => sum + (sub?.projectSpentTimeInsecond || 0),
            0
          );
          const projectOwnTime = trackedTime[project?.task_project_commonFieldForSpentTime] || 0;
          const projectSpentTimeInsecond = projectOwnTime + subProjectsTotalTime;
          return { ...project, projectSpentTimeInsecond, subProjects };
        }
        return projects.map(traverse);
      }



      if (projectList?.length) {
        const filteredProjectWithTime = addAggregatedSpentTime(projectList, projects_trackedTime);
        setFilteredProject(_.cloneDeep(filteredProjectWithTime));
        setProjectArray(_.cloneDeep(filteredProjectWithTime));
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[projects_trackedTime])
  

  useEffect(() => {
    const jiraAccessToken = localStorage.getItem('jiraAccessToken');
    const openProjectAccessToken = localStorage.getItem('openProjectAccessToken');
    if(userDetails){
      if(projectType === projectTypeMenu[0] && openProjectAccessToken) {
        setOpenProjects(_.cloneDeep(projectList));
        getProjectList(projectList);
      } else if (projectType === projectTypeMenu[2] && jiraAccessToken) {
        getJiraProjectList()
      } else {
        setFilteredProject([]);
        setProjectArray([]);
        setLoading(false);
      }
      if(!isIssueTracking){
        dispatch(clearStateIssue());
      }
      dispatch(setStateSelectedProject(null));
      setIsListingAllTask(true)
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectType, userDetails])


  useEffect(()=>{
    if(trackingTimeLogged){
      if(projectType == projectTypeMenu[0]){
        setDailyTrackerTimeByGetAllTaskData({loader:false});
      }
      if(projectType == projectTypeMenu[2]){
        setDailyTrackerTimeByGetAllJiraTask({loader:false});
      }
      dispatch(setTrackingTimeLogged(false));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[projectSelectedProject]);


  useEffect(() => {
    if(isListingAllTask && isIssueTracking){
      if(projectType == projectTypeMenu[0]){
        if(task_project_commonFieldForSpentTime){
          let project = projectArray.find(proj =>{
            if(task_project_commonFieldForSpentTime == proj?.task_project_commonFieldForSpentTime) {
              return true
            }
          })
          if(project?.name){
            let projectLink = project?._links?.self?.href
            const projectSpentTimeInsecond = projects_trackedTime[task_project_commonFieldForSpentTime] || 0
            let projectData = {
              ...project,
              projectSpentTime: projectSpentTimeInsecond,
              projectLink: projectLink,
              task_project_commonFieldForSpentTime: projectLink // project link is common field in open project task and project
            }
            setIsListingAllTask(false)
            dispatch(setStateSelectedProject(projectData));
          }
        }
      }      
      if(projectType == projectTypeMenu[2]){
        let project = projectArray.find(proj =>{
          if(task_project_commonFieldForSpentTime == proj?.task_project_commonFieldForSpentTime) {
            return true
          }
        })
        if(project?.name){
          let projectData = {
            ...project,
          }
          setIsListingAllTask(false)
          dispatch(setStateSelectedProject(projectData));
        }
      }

    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[task_project_commonFieldForSpentTime,isIssueTracking])

  useEffect(() => {
    const jiraAccessToken = localStorage.getItem('jiraAccessToken');
    const openProjectAccessToken = localStorage.getItem('openProjectAccessToken');

    if ((projectType === projectTypeMenu[2]) && jiraAccessToken) {
      setJiraProjects(jiraProjectList);
      getJiraProjectList();
    } else if ((projectType === projectTypeMenu[0]) && openProjectAccessToken) {
      setOpenProjects(_.cloneDeep(projectList));
      getProjectList(projectList);
    } else {
      setLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectList,projectType, projectTypeMenu, jiraProjectList])

  useEffect(() => {
    setLoading(loader);
  }, [loader])

  useEffect(() => {
    if (selectedNotification) {
      if (projectType !== "WayMore Project") dispatch(setProjectType("WayMore Project"));
      if (filteredProject?.length > 0 && projectType === "WayMore Project") {
        const notificationData = selectedNotification?._links?.project;
        const selectedProject = filteredProject.find((list) => list?.name === notificationData?.title && list?.projectLink === notificationData?.href)
        if(selectedProject) {
          handleListSelection("", selectedProject, true);
        }
      }
    }
  }, [selectedNotification, filteredProject, projectType])

  return (
    <div className="projectListDiv">
      <TextField id='project-search' value={searchProject} onInput={handleSearch} size="small"
        placeholder="Search Projects"
        style={{
          margin: '2px 15px',
          position: 'sticky',
          top: 0,
          background: '#ffffff',
          zIndex: 1
        }} />
      <div className="projectListName">
        <Select value={projectType}
          id='project-list-drop-down'
          onChange={(e) => {
            handleProjectTypeChange(e);
            setSelectedNotification(null);
          }}
          sx={{
            width: '100%', textAlign: 'left', fontWeight: '700',
            "& fieldset": {
              border: 'none'
            }
          }}
        > {projectTypeMenu.map((value) => (
            <MenuItem key={value} value={value}>{value} </MenuItem>
          ))}
        </Select>
        {projectType === "WayMore Project" && (<Box onClick={handleNewProjectVisibility} sx={{ width: 24, height: 24, borderRadius: "50%", backgroundColor: "#1976D2", padding: "2px", cursor: "pointer" }}>
          <AddIcon fontSize="medium" sx={{ color: "#fff" }} />
        </Box>)}
        {newProjectVisibility && <NewProject projects={filteredProject}
          newProjectVisibility={newProjectVisibility} setNewProjectVisibility={handleNewProjectVisibility} />}
      </div>
      <div className="circular-progress-loader-container" style={{ overflowY: 'auto' , paddingTop:'20px'}}>
        {loading && (
          <div className="circular-progress-loader-backdrop">
            <div className="circular-progress-loader" >
              <CircularProgress />
            </div>
          </div>
        )}
        {
          (filteredProject.length > 0 ?
            (projectType === "WayMore Project" ? <ProjectHierarchy filteredProject={filteredProject} handleProjectSelection={handleListSelection} /> :
              <List disablePadding={true} className="list-container">
              {
                filteredProject.map((value, index) => (
                  <ListItemButton alignItems="center"
                    key={index}
                    onClick={e => {
                    handleListSelection(e, value);
                    setSelectedNotification(null)
                  }}
                    selected={value.id === projectSelectedProject?.id}
                  >
                    <div className="listDiv">
                      <span className="playIcon">
                        {value.id === projectSelectedProject?.id && <PlayCircleIcon fontSize="small" color="primary"></PlayCircleIcon>}
                        <span>{ value.name }</span>
                      </span>
                      <span>{ formatTimeWithSecond(value?.projectSpentTimeInsecond || 0) }</span>
                    </div>
                  </ListItemButton>
                ))
              }
            </List>) : (!loading && <div>No Results Found</div>))
          }
      </div>

    </div>
  )
}

export default ProjectListPage
